import { ArrowBackIosNew } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, Tooltip, useMediaQuery } from "@mui/material";
import type React from "react";
import { Suspense } from "react";
import iframeCopy from "../../../utills/iframeCopy.ts";
import iframeGoHome from "../../../utills/iframeGoHome.tsx";
import CountdownChip from "./CountdownChip.tsx";
import ShareButtons from "./ShareButtons.tsx";
import { isEvyveska } from "../../../utills/iframeVariants.ts";

const baseUrl = import.meta.env.VITE_ORIGIN_DETAIL;

const Header: React.FC<{ id: number }> = ({ id }) => {
	const shareUrl = `${baseUrl}?id=${id}`;
	const handleCopy = () => {
		iframeCopy(shareUrl);
	};
	const isSmall = useMediaQuery("(max-width:600px)");
	return (
		<Box
			display="flex"
			flexGrow={1}
			flex={1}
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
			sx={(theme) => ({ backgroundColor: theme.palette.grey[200] })}
			position="sticky"
		>
			{isSmall ? (
				<Tooltip title="zpět na seznam inzerátů">
					<IconButton onClick={iframeGoHome} color="info">
						<ArrowBackIosNew />
					</IconButton>
				</Tooltip>
			) : (
				<Button onClick={iframeGoHome} variant="contained" color="info">
					zpět na seznam inzerátů
				</Button>
			)}
			<Stack alignItems="center" justifyContent="flex-end" direction="row" spacing={2}>
				<Suspense>
					<CountdownChip id={id} />
				</Suspense>
        {isEvyveska()?
          null
          :
          <ShareButtons
            contextMenuButtons={["threads", "discord", "whatsapp", "facebook", "linkedin", "twitter", "email", "teams"]}
            onCopy={handleCopy}
            url={shareUrl}
            customCopy={handleCopy}
            prefilledText="inzerat"
          />
        }
			</Stack>
		</Box>
	);
};

export default Header;
